// React and ReactDOM imports
import { scan } from "react-scan";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AuthContextProvider } from "./context/AuthContext";
import MenuBar from "./pages/MenuBar";
import CollectionsChange from "./pages/collections-change/CollectionsChangeRefact";
import Config from "./pages/configuration/Config";
import ControlPanel from "./pages/control-panel/ControlPanel";
import CollectionsManagerRefact from "./pages/events-manager/EventsManager";
import FlowDetectionsRefact from "./pages/flow-detections/FlowDetectionsRefact";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import OpeningHours from "./pages/opening-hours/OpeningHours";
import PeakHoursRefact from "./pages/peak-hours/PeakHoursRefact";
import RevenueRefact from "./pages/revenue/RevenueRefact";
import ZonesManager from "./pages/zones/ZonesManager";
import PrivateRoute from "./utils/PrivateRoute";

scan({
  enabled: process.env.REACT_APP_ENV === "development",
});

const queryClient = new QueryClient({});

const root = ReactDOM.createRoot(document.getElementById("root"));

const protectedRoutes = [
  { router: "/", component: <Home />, menu_item_selected: "home" },
  {
    router: "/flow_detections",
    component: <FlowDetectionsRefact />,
    menu_item_selected: "flow_detections",
  },
  {
    router: "/flow_detections_refact",
    component: <FlowDetectionsRefact />,
    menu_item_selected: "flow_detections",
  },
  {
    router: "/collections_change",
    component: <CollectionsChange />,
    menu_item_selected: "collections_change",
  },
  {
    router: "/peak_hours",
    component: <PeakHoursRefact />,
    menu_item_selected: "peak_hours",
  },
  {
    router: "/events_manager",
    component: <CollectionsManagerRefact />,
    menu_item_selected: "events_manager",
  },
  {
    router: "/revenue",
    component: <RevenueRefact />,
    menu_item_selected: "revenue",
  },
  {
    router: "/zones_manager",
    component: <ZonesManager />,
    menu_item_selected: "zones_manager",
  },
  {
    router: "/settings",
    component: <Config />,
    menu_item_selected: "settings",
  },
  {
    router: "/opening_hours",
    component: <OpeningHours />,
    menu_item_selected: "opening_hours",
  },
  {
    router: "/control_panel",
    component: <ControlPanel />,
    menu_item_selected: "control_panel",
  },
];

const publicRoutes = [{ router: "/login", component: <Login /> }];

root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    {process.env.REACT_APP_ENV === "development" && (
      <ReactQueryDevtools initialIsOpen={true} />
    )}
    <BrowserRouter>
      <AuthContextProvider>
        <Routes>
          {protectedRoutes.map((route) => (
            <Route
              key={route.router}
              path={route.router}
              element={
                <PrivateRoute>
                  <MenuBar menu_item_selected={route.menu_item_selected}>
                    {route.component}
                  </MenuBar>
                </PrivateRoute>
              }
            />
          ))}
          {publicRoutes.map((route) => (
            <Route
              key={route.router}
              path={route.router}
              element={route.component}
            />
          ))}
        </Routes>
      </AuthContextProvider>
    </BrowserRouter>
  </QueryClientProvider>
  // </React.StrictMode>
);
